import { useState } from 'react';
import ModalBtn from '../../molecules/modalButton/view';
import Table from '../../molecules/tablas/view';
import { BsViewList } from 'react-icons/bs';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { getSpend } from '../../../usecases/spend-usecase';
import { IoReload } from 'react-icons/io5';
import { BiCheckCircle } from 'react-icons/bi';
import ShowThird from '../../organisms/showThird/view';

const ListItemsGasto = ({ data, profile }) => {
  const [details, setDetails] = useState(null);

  const formatCurrency = (value) =>
    new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      maximumFractionDigits: 0,
    }).format(value || 0);

  function handleOpen() {
    if (!data?.id) return;
    setDetails(null);
    getSpend(data.id)
      .then((res) => {
        const itemData = res?.data || res;
        setDetails(itemData);
      })
      .catch(() => {
        dispatchCustomEvent('popup', {
          message: 'Error al cargar el detalle del gasto',
          type: 'error',
        });
      });
  }

  const lines = details?.service_lines || [];
  const payments = details?.payment_methods || [];

  const grossAmount = lines.reduce(
    (acc, line) => acc + parseFloat(line.amount || 0),
    0
  ) || parseFloat(details?.amount || 0);

  const taxAmount = lines.reduce(
    (acc, line) => acc + parseFloat(line.tax || 0),
    0
  ) || parseFloat(details?.tax || 0);

  const retentionAmount = lines.reduce(
    (acc, line) => acc + parseFloat(line.retention || 0),
    0
  ) || parseFloat(details?.retention || 0);

  const totalToPay = grossAmount - retentionAmount;

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString('es-CO');
  };

  return (
    <ModalBtn
      id={'spend-' + (data?.id || 'detail')}
      title={<BsViewList />}
      onClick={handleOpen}
      width="85vw"
      type="action"
    >
      {details ? (
        <div className="list-compras-box" style={{ overflow: 'hidden' }}>
          <div className="comprobante-body-grid">
            <div className="comprobante-general-info">
              <div className="info-field-group">
                <span className="info-label">Proveedor / Tercero</span>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <ShowThird
                    id={'spend-detail-' + details.id}
                    data={{ third_id: details.third_id }}
                  />
                </div>
              </div>
              <div className="info-subgrid">
                <div className="info-field-group">
                  <span className="info-label">Tipo Transacción</span>
                  <span className="info-value">Gasto General</span>
                </div>
                <div className="info-field-group">
                  <span className="info-label">Documento</span>
                  <span className="info-value">
                    #{details.id} {details.documento_compra ? `/ ${details.documento_compra}` : ''}
                  </span>
                </div>
              </div>
              <div className="info-subgrid">
                <div className="info-field-group">
                  <span className="info-label">Fecha Registro</span>
                  <span className="info-value">
                    {formatDate(details.spend_date || details.created_at)}
                  </span>
                </div>
              </div>
            </div>

            <div className="balance-card-modern balanced">
              <div className="card-header-status">
                <span className="status-badge">
                  <BiCheckCircle /> ESTADO: REGISTRADO
                </span>
                <span className="resumen-label">RESUMEN DE GASTO</span>
              </div>
              <div
                className="card-totals-grid"
                style={{ gridTemplateColumns: '1fr 1fr' }}
              >
                <div
                  className="total-col"
                  style={{
                    borderRight: '1px solid #d1f2eb',
                    paddingRight: '15px',
                  }}
                >
                  <span className="total-label-modern">Total Bruto</span>
                  <span
                    className="total-amount-modern"
                    style={{ fontSize: '1.4rem' }}
                  >
                    {formatCurrency(grossAmount)}
                  </span>
                </div>
                <div className="total-col" style={{ paddingLeft: '15px' }}>
                  <span className="total-label-modern">Impuestos</span>
                  <span
                    className="total-amount-modern"
                    style={{ fontSize: '1.4rem' }}
                  >
                    {formatCurrency(taxAmount)}
                  </span>
                </div>
              </div>
              <div
                className="card-totals-grid"
                style={{
                  gridTemplateColumns: '1fr 1fr',
                  borderTop: '1px solid #d1f2eb',
                  marginTop: '10px',
                  paddingTop: '10px',
                }}
              >
                <div
                  className="total-col"
                  style={{
                    borderRight: '1px solid #d1f2eb',
                    paddingRight: '15px',
                  }}
                >
                  <span
                    className="total-label-modern"
                    style={{ color: '#e74c3c' }}
                  >
                    Retenciones
                  </span>
                  <span
                    className="total-amount-modern"
                    style={{ fontSize: '1.2rem', color: '#e74c3c' }}
                  >
                    - {formatCurrency(retentionAmount)}
                  </span>
                </div>
                <div className="total-col" style={{ paddingLeft: '15px' }}>
                  <span
                    className="total-label-modern"
                    style={{ fontWeight: '800' }}
                  >
                    TOTAL A PAGAR
                  </span>
                  <span
                    className="total-amount-modern"
                    style={{
                      fontSize: '1.4rem',
                      color: '#27ae60',
                      fontWeight: '800',
                    }}
                  >
                    {formatCurrency(totalToPay)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            className="comprobante-lines-section"
            style={{ maxHeight: '30vh', overflowY: 'auto' }}
          >
            <div className="lines-header-row">
              <h3 className="lines-title-modern">DETALLE DE LÍNEAS DE GASTO</h3>
            </div>
            <Table
              id={'spend-items-' + details.id}
              data={lines.map((line) => {
                const amount = parseFloat(line.amount || 0);
                const ret = parseFloat(line.retention || 0);
                const tax = parseFloat(line.tax || 0);
                return {
                  concept: line.description || line.spend_type_data?.name || 'Gasto General',
                  amount: amount,
                  tax: tax,
                  retention: ret,
                  total: amount - ret,
                };
              })}
              maxHeight="30vh"
              headersList={[
                'CONCEPTO / DESCRIPCIÓN',
                'MONTO BRUTO',
                'IMPUESTO',
                'RETENCIÓN',
                'NETO',
              ]}
              excludeList={['id']}
              formats={{
                amount: { type: 'money' },
                tax: { type: 'money' },
                retention: { type: 'money' },
                total: { type: 'money' },
              }}
            />
          </div>

          <div
            className="comprobante-lines-section"
            style={{ marginTop: '10px' }}
          >
            <div className="lines-header-row">
              <h3 className="lines-title-modern">DISTRIBUCIÓN DE PAGOS</h3>
            </div>
            <Table
              id={'spend-payments-' + details.id}
              headersList={['MÉTODO DE PAGO', 'VALOR PAGADO']}
              excludeList={['id', 'spend_id', 'paymethod_id']}
              data={payments.map((p) => ({
                method: p.method || 'Medio de Pago',
                value: p.value,
              }))}
              maxHeight="15vh"
              formats={{
                value: { type: 'money' },
              }}
            />
          </div>
        </div>
      ) : (
        <div
          className="loading-container"
          style={{ padding: '80px', textAlign: 'center', opacity: 0.6 }}
        >
          <IoReload
            className="spin"
            style={{ fontSize: '2.5rem', marginBottom: '15px' }}
          />
          <p>Cargando información detallada del gasto...</p>
        </div>
      )}
    </ModalBtn>
  );
};

export default ListItemsGasto;
